import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { APISD } from "../../../../../config/apisd";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
// import ModalAdd from "./modal/add";
// import ModalUpdate from "./modal/update";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRectangleList
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";


export default function BukuNilai() {
  document.title = "Buku Nilai";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");

  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const [, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [, setGetDataTeacher] = useState([]);

  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [getData, setGetData] = useState([]);
  const [dataWalas, setDataWalas] = useState(null);

  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [getDataMatpel, setGetDataMatpel] = useState([]);
  const [selectedMatpel, setSelectedMatpel] = useState("");
  const [loadingMatpel, setLoadingMatpel] = useState(false);
  const [loadingBookScore, setLoadingBookScore] = useState(false);
  const [bookHeaders, setBookHeaders] = useState([]);
  const [bookStudents, setBookStudents] = useState([]);
  const [bookWeights, setBookWeights] = useState({});
  const loadedBookKey = useRef("");

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const academicYears = useMemo(() => {
    return Array.from(
      new Set(
        getDataSemesterMap
          .map((semester) => semester?.name_year)
          .filter(Boolean)
      )
    );
  }, [getDataSemesterMap]);

  const semestersInSelectedYear = useMemo(() => {
    return getDataSemesterMap
      .filter((semester) => semester?.name_year === namaTA)
      .sort(
        (a, b) =>
          Number(a?.semester || 0) - Number(b?.semester || 0)
      );
  }, [getDataSemesterMap, namaTA]);

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
    ysb_teacher_id: "",
  });

  const selectedClassName = useMemo(() => {
    const selectedClass = getDataKelas.find(
      (kelas) => String(kelas?.id) === String(form2.ysb_kelas_id)
    );

    return selectedClass?.name_kelas || "Kelas";
  }, [getDataKelas, form2.ysb_kelas_id]);

  const selectedSemesterData = useMemo(
    () =>
      getDataSemesterMap.find(
        (semester) =>
          String(semester?.id) === String(form2.ysb_semester_id)
      ) || null,
    [getDataSemesterMap, form2.ysb_semester_id]
  );

  const location = useLocation();

  const [, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
    } else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate, setPermission]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((controller) => controller.abort());
    };
  }, []);

  const collator = useMemo(
    () =>
      new Intl.Collator("id", {
        numeric: true,
        sensitivity: "base",
      }),
    []
  );

  const safeStr = (value) =>
    value === null || value === undefined ? "" : String(value);

  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((jenjang) =>
        (a.school_name || "").toUpperCase().includes(jenjang)
      );

      const jenjangB = order.findIndex((jenjang) =>
        (b.school_name || "").toUpperCase().includes(jenjang)
      );

      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") {
      return schools.filter(
        (school) => school.school_code !== "BASEMENT_BEKASI"
      );
    }

    return schools;
  };

  const fetchInit = useCallback(async () => {
    setLoading(true);

    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes, dimensiRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
      ]);

      if (!isMounted.current) {
        return;
      }

      if (branchRes?.status === 200) {
        const branches = branchRes?.data?.data || [];

        setGetDataBranch(branches);

        if (branches.length > 0) {
          const firstBranch = branches[0]?.branch_code;

          setForm2((previous) => ({
            ...previous,
            ysb_branch_id: firstBranch,
          }));
        }
      }

      if (semesterRes?.status === 200) {
        const semesters = semesterRes?.data?.data || [];
        const active =
          semesters.find(
            (semester) => Number(semester?.status) === 1
          ) || semesters[0];

        setGetDataSemesterMap(semesters);

        if (active) {
          setNamaTA(active?.name_year || "");
          setNamaSmstr(active?.semester || "");

          setForm2((previous) => ({
            ...previous,
            ysb_semester_id: active?.id,
          }));
        }
      }

      if (dimensiRes?.status === 200) {
        const dimensions = (dimensiRes?.data?.data || []).filter(
          (dimension) => dimension?.status === 1
        );

        setGetDataDimensi(dimensions);

        if (dimensions.length > 0) {
          setForm2((previous) => ({
            ...previous,
            ysb_dimensi_id: dimensions[0]?.id,
          }));
        }
      }
    } catch (error) {
      swal({
        title: "Failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Terjadi kesalahan",
        icon: "error",
      });
    }
  }, [
    ascending,
    descending,
    fetchParams,
    keyword,
    limit,
    page,
    storageBranchGroping,
    storageLevel,
    setGetDataDimensi,
  ]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;

      setLoadingSchool(true);

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let schools = response?.data?.data || [];

          if (
            storageLevel === "developer" ||
            storageLevel === "superadmin"
          ) {
            schools = schools.filter(
              (school) => school?.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          if (schools.length > 0) {
            setGetDataLevel([]);
            setGetDataKelas([]);

            setForm2((previous) => ({
              ...previous,
              ysb_school_id: schools[0]?.school_code,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setGetDataKelas([]);

            setForm2((previous) => ({
              ...previous,
              ysb_school_id: "",
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));

            setGetDataTeacher([]);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        initSchoolDone.current = true;
        setLoadingSchool(false);
        setLoading(false);
      }
    },
    [
      ascending,
      fetchParams,
      limit,
      page,
      storageLevel,
      setGetDataTeacher,
    ]
  );

  useEffect(() => {
    if (form2?.ysb_branch_id) {
      fetchSchoolsByBranch(form2.ysb_branch_id);
    }
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  const sortLevels = (levels) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare(b?.name_level || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const sortKelas = (classes) => {
    return [...classes].sort((a, b) =>
      (a?.name_kelas || "").localeCompare(b?.name_kelas || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;
      initKelasDone.current = false;

      if (!schoolId) {
        return;
      }

      setLoadingLevel(true);

      try {
        const response = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let levels = response?.data?.data || [];

          levels = levels.filter(
            (level) => level?.ysb_school_id === schoolId
          );

          if (branchId) {
            levels = levels.filter(
              (level) => level?.ysb_branch_id === branchId
            );
          }

          levels = sortLevels(levels);

          setGetDataLevel(levels);

          if (levels.length === 0) {
            initKelasDone.current = true;
          }

          if (levels.length > 0) {
            setForm2((previous) => ({
              ...previous,
              ysb_grade_level_id: levels[0]?.id,
            }));
          } else {
            setForm2((previous) => ({
              ...previous,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
            }));

            setGetDataKelas([]);
          }
        }
      } catch (error) {
        console.error(error);

        swal({
          title: "Failed",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));
      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    },
    [ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (!form2?.ysb_school_id) {
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((previous) => ({
        ...previous,
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    setGetDataLevel([]);
    setGetDataKelas([]);

    setForm2((previous) => ({
      ...previous,
      ysb_grade_level_id: "",
      ysb_kelas_id: "",
    }));

    fetchLevelsBySchool(
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchLevelsBySchool,
  ]);

  const fetchKelasByLevel = useCallback(
    async (gradeLevelId, schoolId, branchId) => {
      initKelasDone.current = false;

      if (!gradeLevelId) {
        return;
      }

      setLoadingKelas(true);

      try {
        const response = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let classes = response?.data?.data || [];

          classes = classes.filter(
            (item) => item?.ysb_grade_level_id === gradeLevelId
          );

          if (schoolId) {
            classes = classes.filter(
              (item) => item?.ysb_school_id === schoolId
            );
          }

          if (branchId) {
            classes = classes.filter(
              (item) => item?.ysb_branch_id === branchId
            );
          }

          classes = sortKelas(classes);

          setGetDataKelas(classes);

          if (classes.length > 0) {
            setForm2((previous) => ({
              ...previous,
              ysb_kelas_id: classes[0]?.id,
            }));
          } else {
            setForm2((previous) => ({
              ...previous,
              ysb_kelas_id: "",
            }));
          }
        }
      } catch (error) {
        console.error(error);

        swal({
          title: "Failed",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Gagal mengambil data kelas",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_kelas_id: "",
        }));
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    },
    [
      ascending,
      fetchParams,
      limit,
      page,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2?.ysb_grade_level_id) {
      setGetDataKelas([]);

      setForm2((previous) => ({
        ...previous,
        ysb_kelas_id: "",
      }));

      return;
    }

    setGetDataKelas([]);

    setForm2((previous) => ({
      ...previous,
      ysb_kelas_id: "",
    }));

    fetchKelasByLevel(
      form2.ysb_grade_level_id,
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_grade_level_id,
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchKelasByLevel,
  ]);

  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_grade_level_id &&
    !!form2.ysb_kelas_id &&
    !loadingSchool &&
    !loadingLevel &&
    !loadingKelas;

  const fetchMatpel = useCallback(
    async (currentMatpel = "") => {
      if (!form2.ysb_branch_id || !form2.ysb_grade_level_id) {
        setGetDataMatpel([]);
        setSelectedMatpel("");
        return "";
      }

      setLoadingMatpel(true);

      try {
        const response = await APISD.get("/api/config-matpels", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 100000,
            ascending: true,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_grade_level_id: form2.ysb_grade_level_id,
            ysb_academic_year_id:
              selectedSemesterData?.ysb_academic_year_id ||
              selectedSemesterData?.academic_year_id ||
              selectedSemesterData?.ysb_tahun_ajaran_id ||
              "",
          },
        });

        let matpels = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

        matpels = matpels
          .filter(
            (item) =>
              !item?.ysb_branch_id ||
              String(item.ysb_branch_id) ===
                String(form2.ysb_branch_id)
          )
          .filter(
            (item, index, rows) =>
              rows.findIndex(
                (row) =>
                  String(row?.ysb_matpel_id || row?.id) ===
                  String(item?.ysb_matpel_id || item?.id)
              ) === index
          )
          .sort((a, b) =>
            collator.compare(
              safeStr(a?.name_matpel),
              safeStr(b?.name_matpel)
            )
          );

        const nextMatpel = matpels.some(
          (item) =>
            String(item?.ysb_matpel_id || item?.id) ===
            String(currentMatpel)
        )
          ? currentMatpel
          : matpels[0]?.ysb_matpel_id || matpels[0]?.id || "";

        setGetDataMatpel(matpels);
        setSelectedMatpel(nextMatpel);

        return nextMatpel;
      } catch (error) {
        setGetDataMatpel([]);
        setSelectedMatpel("");

        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal mengambil data mata pelajaran",
          icon: "error",
        });

        return "";
      } finally {
        setLoadingMatpel(false);
      }
    },
    [
      collator,
      fetchParams,
      form2.ysb_branch_id,
      form2.ysb_grade_level_id,
      selectedSemesterData,
    ]
  );

  const fetchBookScore = useCallback(
    async (matpelId) => {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id ||
        !form2.ysb_kelas_id ||
        !matpelId
      ) {
        setBookHeaders([]);
        setBookStudents([]);
        setBookWeights({});
        return;
      }

      setLoadingBookScore(true);

      try {
        const response = await APISD.get(
          "/api/book-exam-scores/show",
          {
            ...fetchParams,
            params: {
              ysb_academic_year_id:
                selectedSemesterData?.ysb_academic_year_id ||
                selectedSemesterData?.academic_year_id ||
                selectedSemesterData?.ysb_tahun_ajaran_id ||
                "",
              ysb_semester_id: form2.ysb_semester_id,
              ysb_branch_id: form2.ysb_branch_id,
              ysb_school_id: form2.ysb_school_id,
              ysb_kelas_id: form2.ysb_kelas_id,
              ysb_matpel_id: matpelId,
            },
          }
        );

        const result = response?.data?.data || {};

        setBookHeaders(
          Array.isArray(result?.header) ? result.header : []
        );
        setBookStudents(
          Array.isArray(result?.data_murid) ? result.data_murid : []
        );
        setBookWeights(
          result?.bobot && typeof result.bobot === "object"
            ? result.bobot
            : {}
        );
      } catch (error) {
        setBookHeaders([]);
        setBookStudents([]);
        setBookWeights({});

        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal mengambil data buku nilai",
          icon: "error",
        });
      } finally {
        setLoadingBookScore(false);
      }
    },
    [
      fetchParams,
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_kelas_id,
      selectedSemesterData,
    ]
  );

  useEffect(() => {
    if (
      getData.length > 0 &&
      getData[0]?.data_element?.length > 0 &&
      !selectedTab
    ) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  useEffect(() => {
    const schoolReady =
      initSchoolDone.current &&
      !loadingSchool &&
      !!form2.ysb_school_id;

    const gradeReady =
      initLevelDone.current &&
      !loadingLevel &&
      !!form2.ysb_grade_level_id;

    const kelasReady =
      initKelasDone.current &&
      !loadingKelas &&
      !!form2.ysb_kelas_id;

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !schoolReady ||
      !gradeReady ||
      !kelasReady
    ) {
      return;
    }

    firstLoadDone.current = true;

    const loadInitialData = async () => {
      setIsFetching(true);

      try {
        // await GetResponseData();
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
      } finally {
        setIsFetching(false);
      }
    };

    loadInitialData();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    loadingSchool,
    loadingLevel,
    loadingKelas,
    // GetResponseData,
  ]);

  useEffect(() => {
    if (
      !hasSearched ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      !form2.ysb_kelas_id
    ) {
      return;
    }

    const filterKey = [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_grade_level_id,
      form2.ysb_kelas_id,
    ].join("|");

    if (loadedBookKey.current === filterKey) {
      return;
    }

    loadedBookKey.current = filterKey;

    const loadBookData = async () => {
      const matpelId = await fetchMatpel();

      if (matpelId) {
        await fetchBookScore(matpelId);
      } else {
        setBookHeaders([]);
        setBookStudents([]);
        setBookWeights({});
      }
    };

    loadBookData();
  }, [
    hasSearched,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    fetchMatpel,
    fetchBookScore,
  ]);

  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
  ]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm2((previous) => ({
      ...previous,
      [name]: value,
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleAcademicYearChange = (event) => {
    const selectedYear = event.target.value;
    const semesters = getDataSemesterMap
      .filter((semester) => semester?.name_year === selectedYear)
      .sort(
        (a, b) =>
          Number(a?.semester || 0) - Number(b?.semester || 0)
      );
    const selectedSemester =
      semesters.find(
        (semester) => Number(semester?.status) === 1
      ) ||
      semesters[0];

    setNamaTA(selectedYear);
    setNamaSmstr(selectedSemester?.semester || "");
    setForm2((previous) => ({
      ...previous,
      ysb_semester_id: selectedSemester?.id || "",
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleSemesterChange = (semester) => {
    setNamaSmstr(semester?.semester || "");
    setForm2((previous) => ({
      ...previous,
      ysb_semester_id: semester?.id || "",
    }));

    setHasSearched(true);
    setIsFilterDirty(false);
  };

  const handleCari = async () => {
    if (loadingSchool || loadingLevel || loadingKelas) {
      swal({
        title: "Mohon tunggu",
        text: "Data sekolah, tingkatan, atau kelas masih dimuat.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });
      return;
    }

    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      !form2.ysb_kelas_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text:
          "Pastikan Semester, Cabang, Sekolah, Tingkatan, dan Kelas sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setDataWalas(null);
    setSelectedMatpel("");
    setGetDataMatpel([]);
    setBookHeaders([]);
    setBookStudents([]);
    setBookWeights({});
    loadedBookKey.current = "";
    setHasSearched(false);
    setIsFetching(true);
    setSearchKeyword("");

    try {
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (error) {
      swal({
        title: "Failed",
        text:
          error?.response?.data?.message ||
          "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const displayedData = useMemo(() => {
    let rows = Array.isArray(getData) ? [...getData] : [];

    const searchValue = safeStr(searchKeyword)
      .trim()
      .toLowerCase();

    if (searchValue) {
      rows = rows.filter((student) => {
        const studentName = safeStr(
          student?.nama_siswa || student?.name_student
        ).toLowerCase();

        const nisn = safeStr(student?.nisn).toLowerCase();

        return (
          studentName.includes(searchValue) ||
          nisn.includes(searchValue)
        );
      });
    }

    rows.sort((a, b) => {
      const orderA =
        a?.order_absen === null ||
        a?.order_absen === undefined ||
        a?.order_absen === ""
          ? null
          : Number(a.order_absen);

      const orderB =
        b?.order_absen === null ||
        b?.order_absen === undefined ||
        b?.order_absen === ""
          ? null
          : Number(b.order_absen);

      const aHasOrder =
        orderA !== null && !Number.isNaN(orderA);

      const bHasOrder =
        orderB !== null && !Number.isNaN(orderB);

      if (!aHasOrder && bHasOrder) {
        return -1;
      }

      if (aHasOrder && !bHasOrder) {
        return 1;
      }

      if (aHasOrder && bHasOrder && orderA !== orderB) {
        return orderA - orderB;
      }

      const nameA = safeStr(
        a?.nama_siswa || a?.name_student
      );

      const nameB = safeStr(
        b?.nama_siswa || b?.name_student
      );

      const nameComparison = collator.compare(nameA, nameB);

      if (nameComparison !== 0) {
        return nameComparison;
      }

      return collator.compare(
        safeStr(a?.nisn),
        safeStr(b?.nisn)
      );
    });

    return rows;
  }, [collator, getData, searchKeyword]);

  const toTitleCase = (value) => {
    const text = safeStr(value).toLowerCase().trim();

    if (!text) {
      return "";
    }

    return text.replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  };

  const totalRows = displayedData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(
      totalRows / Math.max(1, rowsPerPage)
    );

    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;

    return displayedData.slice(start, start + safeRows);
  }, [displayedData, tablePage, rowsPerPage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        pages.push(pageNumber);
      }

      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (let pageNumber = left; pageNumber <= right; pageNumber++) {
      if (pageNumber !== 1 && pageNumber !== totalPages) {
        pages.push(pageNumber);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const selectedPage = Math.min(
      Math.max(1, Number(nextPage) || 1),
      totalPages
    );

    setTablePage(selectedPage);
  };

  const getBookHeaderWeightInfo = useCallback(
    (title) => {
      const normalizedTitle = safeStr(title).trim().toLowerCase();
      const formatWeight = (value) =>
        value === null || value === undefined || value === ""
          ? "-"
          : `${value}%`;

      if (normalizedTitle === "rata-rata sumatif akhir") {
        return `Bobot ASTS: ${formatWeight(
          bookWeights?.asts
        )}\nBobot ASAS: ${formatWeight(bookWeights?.asas)}`;
      }

      if (normalizedTitle === "nilai rapor") {
        return `Bobot Sumatif Harian: ${formatWeight(
          bookWeights?.sumatif_harian
        )}\nBobot Sumatif Akhir: ${formatWeight(
          bookWeights?.sumatif_akhir
        )}`;
      }

      return "";
    },
    [bookWeights]
  );

  const bookLeafHeaders = useMemo(
    () =>
      bookHeaders.flatMap((header) => {
        const children = Array.isArray(header?.ysb_matpel_tp)
          ? header.ysb_matpel_tp
          : [];

        return children.length
          ? children.map((child) => ({
              ...child,
              parentTitle: header?.title || "-",
              isTp: true,
            }))
          : [
              {
                ...header,
                parentTitle: header?.title || "-",
                isTp: false,
              },
            ];
      }),
    [bookHeaders]
  );

  const filteredBookStudents = useMemo(() => {
    const searchValue = safeStr(searchKeyword).trim().toLowerCase();

    return [...bookStudents]
      .filter((student) =>
        searchValue
          ? safeStr(student?.nama_lengkap)
              .toLowerCase()
              .includes(searchValue)
          : true
      )
      .sort((a, b) =>
        collator.compare(
          safeStr(a?.nama_lengkap),
          safeStr(b?.nama_lengkap)
        )
      );
  }, [bookStudents, collator, searchKeyword]);

  const getBookStudentValue = useCallback((student, header) => {
    const headerTitle = safeStr(
      header?.title || header?.parentTitle
    ).toLowerCase();

    if (headerTitle === "nama") {
      const studentName = String(student?.nama_lengkap || "")
        .toLowerCase()
        .trim()
        .replace(/\w\S*/g, (word) =>
          word.charAt(0).toUpperCase() + word.slice(1)
        );

      return studentName || "-";
    }

    if (header?.isTp) {
      const scoreData = Array.isArray(student?.data_nilai)
        ? student.data_nilai.find(
            (item) =>
              String(item?.ysb_matpel_tp_id) === String(header?.id)
          )
        : null;

      return scoreData?.score === null ||
        scoreData?.score === undefined ||
        scoreData?.score === ""
        ? "-"
        : scoreData.score;
    }

    const keyMap = {
      "rata-rata sumatif harian": "rata_rata_sumatif_harian",
      asts: "asts",
      asas: "asas",
      "rata-rata sumatif akhir": "rata_rata_sumatif_akhir",
      "nilai rapor": "nilai_rapor",
    };
    const key = keyMap[headerTitle];
    const value = key ? student?.[key] : null;

    return value === null || value === undefined || value === ""
      ? "-"
      : value;
  }, []);

  return (
    <>
      {/* <style>{shimmerStyle}</style> */}

      <style>{`
        .leger-table-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 10px 22px;
          border-bottom: 1px solid #e5eaf3;
        }

        .leger-table-title {
          margin: 0;
          color: #111827;
          font-size: 17px;
          font-weight: 700;
        }

        .leger-semester-tabs {
          display: flex;
          gap: 4px;
          padding: 4px;
          border: 1px solid #dce3ee;
          border-radius: 12px;
          background: #f8fafc;
        }

        .leger-semester-tab {
          min-width: 100px;
          padding: 10px 14px;
          border: 0;
          border-radius: 9px;
          background: transparent;
          color: #64748b;
          font-weight: 700;
          cursor: pointer;
          font-size: 13px;
        }

        .leger-semester-tab.active {
          background: #ffffff;
          color: #3f5bea;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
        }

        .book-content {
          padding: 12px 10px 0;
        }

        .book-toolbar {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 16px;
        }

        .book-subject {
          width: 280px;
          min-width: 240px;
          height: 46px;
          padding: 0 42px 0 16px;
          border: 1px solid #dbe3f0;
          border-radius: 13px;
          outline: none;
          background: #ffffff;
          color: #1f2937;
          font-size: 14px;
        }

        .book-search {
          flex: 1;
          width: 100%;
          height: 46px;
          padding: 0 18px;
          border: 1px solid #dbe3f0;
          border-radius: 13px;
          outline: none;
          color: #1f2937;
          font-size: 14px;
        }

        .book-subject:focus,
        .book-search:focus {
          border-color: #3f5bea;
          box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.1);
        }

        .book-table-wrap {
          width: 100%;
          max-height: calc(100vh - 210px);
          overflow: auto;
          scrollbar-color: #cbd5e1 transparent;
          scrollbar-width: thin;
          -webkit-overflow-scrolling: touch;
        }

        .book-table-wrap::-webkit-scrollbar {
          width: 9px;
          height: 9px;
        }

        .book-table-wrap::-webkit-scrollbar-track {
          background: transparent;
        }

        .book-table-wrap::-webkit-scrollbar-thumb {
          border-radius: 999px;
          background: #cbd5e1;
        }

        .book-table {
          width: 100%;
          min-width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          color: #334155;
          font-size: 13px;
        }

        .book-table.book-table-full {
          table-layout: fixed;
        }

        .book-table th,
        .book-table td {
          min-width: 165px;
          height: 72px;
          padding: 14px 16px;
          border-left: 1px solid #e2e8f0;
          border-bottom: 1px solid #e2e8f0;
          text-align: center;
          white-space: nowrap;
        }

        .book-table th:last-child,
        .book-table td:last-child {
          border-right: 1px solid #e2e8f0;
        }

        .book-table th {
          position: sticky;
          top: 0;
          z-index: 6;
          height: 70px;
          background: #f2f3fc;
          color: #172554;
          font-weight: 700;
          white-space: normal;
          vertical-align: middle;
        }

        .book-table thead tr:nth-child(2) th {
          top: 70px;
          z-index: 7;
        }

        .book-table thead tr:nth-child(2) th.book-subheader {
          left: auto;
          min-width: 165px;
          max-width: none;
          text-align: center;
          box-shadow: none;
        }

        .book-table tbody tr:nth-child(even) td {
          background: #f8fafc;
        }

        .book-table tbody tr:nth-child(odd) td {
          background: #ffffff;
        }

        .book-table th:first-child,
        .book-table td:first-child {
          position: sticky;
          left: 0;
          z-index: 3;
          width: 68px;
          min-width: 68px;
          max-width: 68px;
          padding-right: 8px;
          padding-left: 8px;
        }

        .book-table th:first-child {
          z-index: 9;
          background: #f2f3fc;
        }

        .book-table th:nth-child(2),
        .book-table td:nth-child(2) {
          position: sticky;
          left: 68px;
          z-index: 2;
          min-width: 250px;
          max-width: 250px;
          text-align: left;
          white-space: normal;
        }

        .book-table th:nth-child(2) {
          z-index: 8;
          background: #f2f3fc;
          box-shadow: 5px 0 10px -10px rgba(0, 76, 255, 0.55);
        }

        .book-table td:nth-child(2) {
          color: #1f2937;
          font-weight: 600;
          box-shadow: 5px 0 10px -10px rgba(0, 76, 255, 0.55);
        }

        .book-table td.book-score-cell {
          text-align: center !important;
          vertical-align: middle;
        }

        .book-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border: 1px solid #d4ddff;
          border-radius: 50%;
          background: #f5f7ff;
          color: #3f5bea;
          font-size: 13px;
          font-weight: 700;
        }

        .book-header-title {
          display: block;
          min-width: 0;
          max-width: 220px;
          line-height: 1.35;
          white-space: normal;
          overflow-wrap: break-word;
        }

        .book-summary-header {
          background: #e8edff !important;
          color: #243b86 !important;
          text-align: center !important;
        }

        .book-summary-header:hover,
        .book-summary-header:focus-within {
          z-index: 30 !important;
        }

        .book-header-label {
          display: inline-flex;
          align-items: center;
          justify-content: center !important;
          gap: 7px;
        }

        .book-weight-info {
          position: relative;
          display: inline-flex;
          flex: 0 0 auto;
          align-items: center;
          justify-content: center;
          width: 19px;
          height: 19px;
          padding: 0;
          border: 0;
          border-radius: 50%;
          background: #3f5bea;
          color: #ffffff;
          font-size: 12px;
          font-weight: 800;
          line-height: 1;
          cursor: help;
        }

        .book-weight-info::after {
          content: attr(data-tooltip);
          position: absolute;
          z-index: 50;
          top: calc(100% + 10px);
          right: 50%;
          width: max-content;
          max-width: 290px;
          padding: 9px 11px;
          border-radius: 8px;
          background: #172554;
          color: #ffffff;
          font-size: 11px;
          font-weight: 500;
          line-height: 1.45;
          text-align: left;
          white-space: pre-line;
          box-shadow: 0 8px 20px rgba(15, 23, 42, 0.2);
          opacity: 0;
          visibility: hidden;
          transform: translateX(50%) translateY(-4px);
          transition: opacity 0.18s ease, transform 0.18s ease,
            visibility 0.18s ease;
          pointer-events: none;
        }

        .book-weight-info:hover::after,
        .book-weight-info:focus-visible::after {
          opacity: 1;
          visibility: visible;
          transform: translateX(50%) translateY(0);
        }

        .book-empty {
          padding: 32px 18px !important;
          color: #94a3b8;
          text-align: center !important;
        }

        @media (max-width: 576px) {
          .leger-table-header {
            align-items: flex-start;
            flex-direction: column;
          }

          .leger-semester-tabs,
          .leger-semester-tab {
            width: 100%;
          }

          .book-toolbar {
            align-items: stretch;
            flex-direction: column;
            gap: 10px;
          }

          .book-subject,
          .book-search {
            width: 100%;
            min-width: 0;
          }
        }
      `}</style>

      <div className="body sims-page">

        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faRectangleList} />
              </span>

              <h4 className="page-title-text">
                Buku Nilai
              </h4>
            </div>

          </div>
        </div>

        <div className="body-content sims-content">
          {loading ? (
            <div className="sims-filter-card">
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={`filter-skeleton-${index}`}
                  className="shimmer sims-filter-skeleton"
                />
              ))}

            </div>
          ) : (
            <div className="sims-filter-card">
              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tahun Ajaran
                </label>

                <select
                  className="sims-filter-select"
                  name="academic_year"
                  value={namaTA}
                  onChange={handleAcademicYearChange}
                >
                  <option value="" disabled>
                    Pilih Tahun Ajaran
                  </option>

                  {academicYears.map((academicYear, index) => (
                    <option
                      key={academicYear || index}
                      value={academicYear}
                    >
                      {academicYear}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Cabang
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map((branch, index) => (
                    <option
                      key={branch?.branch_code || index}
                      value={branch?.branch_code}
                    >
                      {branch?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Sekolah
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={
                    loadingSchool ||
                    !form2.ysb_branch_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map((school, index) => (
                      <option
                        key={school?.school_code || index}
                        value={school?.school_code}
                      >
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tingkatan
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_grade_level_id"
                  value={form2.ysb_grade_level_id}
                  onChange={handleChange}
                  disabled={
                    loadingLevel ||
                    !form2.ysb_school_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_school_id
                      ? "Pilih Sekolah terlebih dahulu"
                      : loadingLevel
                      ? "Memuat data tingkatan..."
                      : "Pilih Tingkatan"}
                  </option>

                  {!loadingLevel &&
                    getDataLevel.map((level, index) => (
                      <option
                        key={level?.id || index}
                        value={level?.id}
                      >
                        {level?.name_level}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Kelas
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_kelas_id"
                  value={form2.ysb_kelas_id}
                  onChange={handleChange}
                  disabled={
                    loadingKelas ||
                    !form2.ysb_grade_level_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_grade_level_id
                      ? "Pilih Tingkatan terlebih dahulu"
                      : loadingKelas
                      ? "Memuat data kelas..."
                      : "Pilih Kelas"}
                  </option>

                  {!loadingKelas &&
                    getDataKelas.map((kelas, index) => (
                      <option
                        key={kelas?.id || index}
                        value={kelas?.id}
                      >
                        {kelas?.name_kelas}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-action">
                <button
                  type="button"
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="sims-filter-button"
                >
                  Tampilkan Data
                </button>
              </div>
            </div>
          )}

          {isFetching && (
            <div className="sims-loading">
              <PulseLoader color="#3f5bea" size={12}/>
            </div>
          )}

          {hasSearched && !isFetching && (
            <>

              <div className="sims-table-card ">
                <div className="leger-table-header">
                  <h5 className="leger-table-title">
                    Buku Nilai - Semester {namaSmstr || "-"}
                  </h5>

                  <div className="leger-semester-tabs">
                    {semestersInSelectedYear.map((semester, index) => (
                      <button
                        type="button"
                        key={semester?.id || index}
                        className={`leger-semester-tab ${
                          String(form2.ysb_semester_id) ===
                          String(semester?.id)
                            ? "active"
                            : ""
                        }`}
                        onClick={() => handleSemesterChange(semester)}
                      >
                        Semester {semester?.semester}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="book-content">
                  <div className="book-toolbar">
                    <select
                      className="book-subject"
                      value={selectedMatpel}
                      onChange={(event) => {
                        const matpelId = event.target.value;

                        setSelectedMatpel(matpelId);
                        setSearchKeyword("");
                        setBookHeaders([]);
                        setBookStudents([]);
                        setBookWeights({});
                        fetchBookScore(matpelId);
                      }}
                      disabled={
                        loadingMatpel || getDataMatpel.length === 0
                      }
                    >
                      <option value="" disabled>
                        {loadingMatpel
                          ? "Memuat mata pelajaran..."
                          : "Pilih Mata Pelajaran"}
                      </option>

                      {getDataMatpel.map((matpel, index) => (
                        <option
                          key={
                            matpel?.ysb_matpel_id || matpel?.id || index
                          }
                          value={
                            matpel?.ysb_matpel_id || matpel?.id || ""
                          }
                        >
                          {matpel?.name_matpel || "-"}
                        </option>
                      ))}
                    </select>

                    <input
                      type="search"
                      className="book-search"
                      placeholder="Cari Nama Siswa"
                      value={searchKeyword}
                      onChange={(event) =>
                        setSearchKeyword(event.target.value)
                      }
                    />
                  </div>
                </div>

                {loadingBookScore || loadingMatpel ? (
                  <div className="sims-loading">
                    <PulseLoader color="#3f5bea" size={12} />
                  </div>
                ) : (
                  <div className="book-table-wrap">
                    <table
                      className={`book-table ${
                        bookLeafHeaders.length <= 5
                          ? "book-table-full"
                          : ""
                      }`}
                    >
                      <thead>
                        <tr>
                          <th rowSpan={2} className="text-center">No</th>

                          {bookHeaders.map((header, index) => {
                            const children = Array.isArray(
                              header?.ysb_matpel_tp
                            )
                              ? header.ysb_matpel_tp
                              : [];
                            const weightInfo = getBookHeaderWeightInfo(
                              header?.title
                            );

                            return (
                              <th
                                key={`${header?.title || "header"}-${index}`}
                                colSpan={Math.max(
                                  children.length,
                                  Number(header?.colspan) || 1
                                )}
                                rowSpan={children.length ? 1 : 2}
                                className={
                                  weightInfo ? "book-summary-header" : ""
                                  
                                }
                                style={{textAlign: "center"}}
                              >
                                <span className="book-header-label text-center">
                                  <span className="book-header-title text-center">
                                    {header?.title || "-"}
                                  </span>

                                  {weightInfo && (
                                    <button
                                      type="button"
                                      className="book-weight-info"
                                      data-tooltip={weightInfo}
                                      aria-label={`Lihat bobot ${
                                        header?.title || "header"
                                      }`}
                                    >
                                      !
                                    </button>
                                  )}
                                </span>
                              </th>
                            );
                          })}
                        </tr>

                        <tr>
                          {bookHeaders.flatMap((header, headerIndex) =>
                            (Array.isArray(header?.ysb_matpel_tp)
                              ? header.ysb_matpel_tp
                              : []
                            ).map((tp, tpIndex) => (
                              <th
                                className="book-subheader"
                                key={
                                  tp?.id || `${headerIndex}-${tpIndex}`
                                }
                              >
                                <span className="book-header-title">
                                  {tp?.name_tp || "-"}
                                </span>
                              </th>
                            ))
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {filteredBookStudents.length > 0 ? (
                          filteredBookStudents.map((student, index) => (
                            <tr
                              key={student?.ysb_student_id || index}
                            >
                              <td className="text-center">
                                <span className="book-number">
                                  {index + 1}
                                </span>
                              </td>

                              {bookLeafHeaders.map(
                                (header, headerIndex) => (
                                  <td
                                    className={
                                      safeStr(
                                        header?.title || header?.parentTitle
                                      )
                                        .trim()
                                        .toLowerCase() === "nama"
                                        ? "book-name-cell"
                                        : "book-score-cell"
                                    }
                                    key={
                                      header?.id ||
                                      `${header?.parentTitle}-${headerIndex}`
                                    }
                                  >
                                    {getBookStudentValue(student, header)}
                                  </td>
                                )
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              className="book-empty"
                              colSpan={Math.max(
                                bookLeafHeaders.length + 1,
                                1
                              )}
                            >
                              {searchKeyword
                                ? "Nama siswa tidak ditemukan"
                                : selectedMatpel
                                ? "Buku nilai belum tersedia"
                                : "Mata pelajaran belum tersedia"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* {displayedData.length > 0 && (
                  <div className="sims-pagination">
                    <div className="sims-pagination-left">
                      <span className="sims-page-info">
                        Menampilkan{" "}
                        <b>
                          {Math.min(
                            (tablePage - 1) *
                              rowsPerPage +
                              1,
                            totalRows
                          )}
                        </b>
                        -
                        <b>
                          {Math.min(
                            tablePage * rowsPerPage,
                            totalRows
                          )}
                        </b>{" "}
                        dari <b>{totalRows}</b> data
                      </span>

                      <select
                        className="sims-page-size"
                        value={rowsPerPage}
                        onChange={(event) => {
                          const value =
                            Number(event.target.value) || 10;

                          setRowsPerPage(value);
                          setTablePage(1);
                        }}
                      >
                        <option value={10}>
                          10 data / halaman
                        </option>

                        <option value={25}>
                          25 data / halaman
                        </option>

                        <option value={50}>
                          50 data / halaman
                        </option>

                        <option value={100}>
                          100 data / halaman
                        </option>
                      </select>
                    </div>

                    <div className="sims-pagination-right">
                      <button
                        type="button"
                        className="sims-page-nav"
                        onClick={() =>
                          goToPage(tablePage - 1)
                        }
                        disabled={tablePage <= 1}
                      >
                        Sebelumnya
                      </button>

                      <div className="sims-page-numbers">
                        {pageNumbers.map(
                          (pageNumber, index) =>
                            pageNumber === "..." ? (
                              <span
                                key={`dots-${index}`}
                                className="sims-page-dots"
                              >
                                ...
                              </span>
                            ) : (
                              <button
                                type="button"
                                key={`page-${pageNumber}`}
                                className={`sims-page-number ${
                                  pageNumber === tablePage
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                  goToPage(pageNumber)
                                }
                              >
                                {pageNumber}
                              </button>
                            )
                        )}
                      </div>

                      <button
                        type="button"
                        className="sims-page-nav"
                        onClick={() =>
                          goToPage(tablePage + 1)
                        }
                        disabled={tablePage >= totalPages}
                      >
                        Selanjutnya
                      </button>
                    </div>
                  </div>
                )} */}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
